// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(116deg, #1e1f20 0%, #313a4c 50%, #101d4a 100%);
  font-family: "Inter", sans-serif;
}

.login-card {
  text-align: center;
  background: rgba(255, 255, 255, 0.08);
  -webkit-backdrop-filter: blur(8px);
          backdrop-filter: blur(8px);
  border-radius: 1rem;
  padding: 3rem 4rem;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.25);
}

.login-title {
  font-size: 1.8rem;
  margin-bottom: 1rem;
  color: #fff;
}

.login-subtitle {
  font-size: 1.1rem;
  font-weight: 300;
  margin-bottom: 2rem;
  color: #e3e8ff;
}

.btn-primary {
  position: relative;
  display: inline-block;
  background: linear-gradient(150deg, #4f8df9 0%, #2448c9 100%);
  color: #fff;
  font-weight: 600;
  padding: 0.75rem 2.5rem;
  font-size: 1rem;
  border: none;
  border-radius: 3rem;
  cursor: pointer;
  overflow: hidden;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}
.btn-primary:before {
  content: "";
  position: absolute;
  inset: 0;
  background: linear-gradient(135deg, #4f8df9 0%, #2448c9 100%);
  z-index: -1;
  transition: opacity 0.2s ease;
  opacity: 0;
  border-radius: 3rem;
}
.btn-primary:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.3);
}
.btn-primary:hover:before {
  opacity: 1;
}
.btn-primary:active {
  transform: translateY(0);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
}`, "",{"version":3,"sources":["webpack://./src/container/Login/Login.scss"],"names":[],"mappings":"AAMA;EACE,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,0EAAA;EACA,gCAAA;AALF;;AAQA;EACE,kBAAA;EACA,qCAAA;EACA,kCAAA;UAAA,0BAAA;EACA,mBAAA;EACA,kBAAA;EACA,0CAAA;AALF;;AAQA;EACE,iBAAA;EACA,mBAAA;EACA,WAAA;AALF;;AAQA;EACE,iBAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;AALF;;AAQA;EACE,kBAAA;EACA,qBAAA;EACA,6DAAA;EACA,WAAA;EACA,gBAAA;EACA,uBAAA;EACA,eAAA;EACA,YAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,qDAAA;AALF;AAOE;EACE,WAAA;EACA,kBAAA;EACA,QAAA;EACA,6DAAA;EACA,WAAA;EACA,6BAAA;EACA,UAAA;EACA,mBAAA;AALJ;AAQE;EACE,2BAAA;EACA,yCAAA;AANJ;AASE;EAAiB,UAAA;AANnB;AAQE;EACE,wBAAA;EACA,yCAAA;AANJ","sourcesContent":["\n$blue-light: #4f8df9;\n$blue: #316fe7;\n$blue-dark: #2448c9;\n\n\n.login-page {\n  min-height: 100vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: linear-gradient(116deg, #1e1f20 0%, #313a4c 50%, #101d4a 100%);\n  font-family: \"Inter\", sans-serif;\n}\n\n.login-card {\n  text-align: center;\n  background: rgba(255, 255, 255, 0.08);\n  backdrop-filter: blur(8px);\n  border-radius: 1rem;\n  padding: 3rem 4rem;\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.25);\n}\n\n.login-title {\n  font-size: 1.8rem;\n  margin-bottom: 1rem;\n  color: #fff;\n}\n\n.login-subtitle {\n  font-size: 1.1rem;\n  font-weight: 300;\n  margin-bottom: 2rem;\n  color: #e3e8ff;\n}\n\n.btn-primary {\n  position: relative;\n  display: inline-block;\n  background: linear-gradient(150deg, $blue-light 0%, $blue-dark 100%);\n  color: #fff;\n  font-weight: 600;\n  padding: 0.75rem 2.5rem;\n  font-size: 1rem;\n  border: none;\n  border-radius: 3rem;\n  cursor: pointer;\n  overflow: hidden;\n  transition: transform 0.2s ease, box-shadow 0.2s ease;\n\n  &:before {\n    content: '';\n    position: absolute;\n    inset: 0;\n    background: linear-gradient(135deg, $blue-light 0%, $blue-dark 100%);\n    z-index: -1;\n    transition: opacity 0.2s ease;\n    opacity: 0;\n    border-radius: 3rem;\n  }\n\n  &:hover {\n    transform: translateY(-2px);\n    box-shadow: 0 6px 18px rgba(0, 0, 0, 0.3);\n  }\n\n  &:hover:before { opacity: 1; }\n\n  &:active {\n    transform: translateY(0);\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
